import {DatePipe} from '@angular/common';
import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort, Sort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {IAvailableTypes} from '../../../../core/models/available-types.interface';
import {ICategory} from '../../../../core/models/category.interface';
import {PageParams} from '../../../../core/models/page-params.model';
import {ConstantService} from '../../../../core/services/constant.service';
import {UploadFileService} from '../../../../core/services/upload-file.service';
import {UserService} from '../../../../core/services/user.service';
import {FileStatus} from '../../../../shared/enums/file-status.enum';
import {SaleOrderInvoiceType} from '../../../../shared/enums/sale-order-invoice-type.enum';

const Field_List_Value: any =
    {
        reorder: false,
        eciOrderDate: false,
        orderId: false,
        stripeAmount: false,
        stripeRefundAmount: false,
        marketplaceVat: false,
    };

@Component({
    selector: 'eci-ind-vat-table-sales-order-upload-history',
    templateUrl: './ind-vat-table-sales-order-upload-history.component.html',
    styleUrls: ['./ind-vat-table-sales-order-upload-history.component.scss']
})

export class TableSalesOrderUploadHistoryComponent implements OnInit {

    constructor(
        private router: Router,
        public userSvc: UserService,
        public uploadFileSvc: UploadFileService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        public dialog: MatDialog,
    ) {
    }
    @Input() dataSource;
    @Input() displayedColumns;
    @Input() availableCategories: ICategory[];
    @Input() availableTypes: IAvailableTypes;
    @Input() showDownloadBtn: boolean = true;
    @Input() pageParams: PageParams = new PageParams();
    @Input() listOfSelectedItems: number[] = [];
    @Input() isCreateMode: boolean;
    @Input() showConsolidateBtn: boolean = false;
    @Output() listOfSelectedItemsChange: EventEmitter<number[]> = new EventEmitter<number[]>(null);
    @Output() pageChange: EventEmitter<PageParams> = new EventEmitter<PageParams>(null);
    @Output() editProducts: EventEmitter<number> = new EventEmitter<number>(null);
    @Output() downInvoice: EventEmitter<number> = new EventEmitter<number>(null);
    @Output() sortRows: EventEmitter<Sort> = new EventEmitter<Sort>(null);
    @Output() downloadDocument: EventEmitter<{file: any}> = new EventEmitter<{file: any}>(null);
    @Output() documentUpload: EventEmitter<{ id: number, e: any, file: any }> = new EventEmitter<{ id: number, e: any, file: any }>(null);
    @Output() documentDelete: EventEmitter<number> = new EventEmitter<number>(null);
    @Output() exportSalesToExcel: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() consolidateShipments: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() showEditInvoicePopup: EventEmitter<{ id: number, type: string }> = new EventEmitter<{ id: number, type: string }>(null);
    @Output() documentSaveElement: EventEmitter<number> = new EventEmitter<number>(null);
    @Output() documentUploadElement: EventEmitter<any> = new EventEmitter<any>(null);
    hiddenFieldList = Field_List_Value;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('table', { static: true, read: ElementRef }) table: ElementRef;

    get documentFileTypes(): string[] {
        return [...this.uploadFileSvc.textFileFormats, ...this.uploadFileSvc.fileFormats]
    }

    pageChanged(e): void {
        this.pageChange.emit(e);
        this.table.nativeElement.scrollIntoView();
    }

    ngOnInit(): void {
        if (this.userSvc.isAdmin) {
            this.constSvc.getSettingsDetails('INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE').subscribe(data => {
                if (data.value) {
                    let fields = JSON.parse(data.value);
                    fields.map(field => {
                        this.hiddenFieldList[field.key] = field.value;
                    });
                }
            });
        }
    }

    downloadInvoice(id): void {
        this.downInvoice.emit(id);
    }

    sortData(e: Sort): void {
        this.sortRows.emit(e);
    }

    get hideCol(): boolean {
        return this.userSvc.isDelicated;
    }

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    get fieldList(): any {
        return this.hiddenFieldList;
    }

    get isDelegateAdmin(): boolean {
        return this.userSvc.isDelegatedAdmin;
    }

    get isAllSelected(): boolean {
        return this.listOfSelectedItems?.length > 0 &&
            this.listOfSelectedItems?.length === this.dataSource?.length;
    }

    isChecked(id: number): boolean {
        return !!this.listOfSelectedItems.find(el => el === id);
    }

    isCancelNote(id: number): boolean {
        return this.dataSource.find(el => el.id === id)?.type === SaleOrderInvoiceType.CANCEL_NOTE;
    }

    dateConvert(date: any): string {
        if (!date) return null;
        return this.datePipe.transform(new Date(date).toISOString().slice(0, 16), 'dd/MM/yyyy hh:mm a');
    }

    uploadShow(status: number): boolean {
        return status == FileStatus.PENDING;
    }

    uploadFile(e, file, id): void {
        this.documentUpload.emit({ id: id, e: e, file: file });
    }

    downloadFile(file: any): void {
        this.downloadDocument.emit({file: file});
    }

    getTableRowColor(row: any): string {
        switch (true) {
            case row?.hasReorder && (this.isAdmin || this.isDelegateAdmin): return 'bisquit';
            case row?.isDuplicateOrder: return 'gray';
            case row?.hasDuplicate: return 'duplicate';
            default: ''
        }
    }

}
